import { of } from "rxjs";
import { filter } from "rxjs/operators";

export function waitForUserInitialized(store: { userInitialized?: () => boolean }) {
    return of(store.userInitialized?.()).pipe(filter(Boolean));
}
